<template>
  <PropertyDetailsCard>
    <template #title>Rent Amount</template>
    <template #action>
      <PropertyDetailsCardEditButton v-if="hasInfo" @click="showModal" />
    </template>

    <PropertyLeaseConditionsInfo v-if="hasInfo" :property="property" />
    <PropertyDetailsCardPlaceholder
      v-else
      title="You haven't set your rent amount yet"
      subtitle="Enter your rent amount to stand out in the market"
      button-text="Add rent amount"
      @button-clicked="showModal"
    />
    <PropertyLeaseConditionsModal ref="leaseConditionsModalRef" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
  PropertyLeaseConditionsInfo,
} from '@tallo/property';

import PropertyLeaseConditionsModal from './property-lease-conditions-modal.vue';

const leaseConditionsModalRef = ref<InstanceType<typeof PropertyLeaseConditionsModal>>();
const { property } = usePropertyStore();
const hasInfo = computed(() => Boolean(property?.leaseConditions));

function showModal() {
  leaseConditionsModalRef.value?.modalRef?.show();
}
</script>
